/**
 * Hand a generated file to the browser.
 *
 * Lives here rather than beside the code that builds the text, because that
 * code is shared with `scripts/checkShareholderCsv.ts` and the scripts project
 * has no DOM. A single `document.createElement` in a module a script imports
 * turns a green typecheck red, which is the same cross-boundary mistake as a
 * script reaching into a Cloud Function — see `storeRevenueCore.ts`.
 *
 * The BOM belongs here too. It is a property of how a file is handed to Excel,
 * not of the register that produced it, and `toCsv` returning a string with an
 * invisible character at the front would make every test of that string wrong
 * in a way nobody could see.
 */
const BOM = String.fromCharCode(0xfeff)

export function downloadCsv(filename: string, text: string): void {
  const blob = new Blob([BOM + text], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  // Long enough for the click to be handled; the object leaks otherwise.
  setTimeout(() => URL.revokeObjectURL(url), 2000)
}
